import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProofPhotoGallery = ({ proofs, currentUserId }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  if (!proofs || proofs?.length === 0) {
    return (
      <div className="p-4 bg-muted/30 rounded-xl text-center">
        <Icon name="Image" size={32} className="text-muted-foreground mx-auto mb-2" />
        <p className="text-sm text-muted-foreground">
          No hay fotos de verificación aún
        </p>
      </div>
    );
  }

  const photoProofs = proofs?.filter(proof => proof?.photo_url);

  if (photoProofs?.length === 0) {
    return (
      <div className="p-4 bg-muted/30 rounded-xl text-center">
        <Icon name="Image" size={32} className="text-muted-foreground mx-auto mb-2" />
        <p className="text-sm text-muted-foreground">
          No hay fotos de verificación aún
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <h4 className="text-sm font-semibold text-foreground flex items-center">
        <Icon name="Image" size={16} className="mr-2" />
        Fotos de Verificación ({photoProofs?.length})
      </h4>
      <div className="grid grid-cols-3 gap-2">
        {photoProofs?.map((proof, index) => (
          <motion.div
            key={proof?.id}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.05 }}
            onClick={() => setSelectedPhoto(proof)}
            className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group"
          >
            <img
              src={proof?.photo_url}
              alt={`Foto de verificación del ${new Date(proof.proof_date)?.toLocaleDateString('es-ES')}`}
              className="w-full h-full object-cover transition-transform group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
              <Icon
                name="Maximize2"
                size={20}
                className="text-white opacity-0 group-hover:opacity-100 transition-opacity"
              />
            </div>
            {proof?.user_id === currentUserId && (
              <div className="absolute top-1 right-1 bg-primary/90 rounded-full p-1">
                <Icon name="User" size={12} className="text-white" />
              </div>
            )}
          </motion.div>
        ))}
      </div>
      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedPhoto && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedPhoto(null)}
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            />
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              className="relative max-w-4xl w-full bg-card rounded-xl overflow-hidden"
              onClick={(e) => e?.stopPropagation()}
            >
              <div className="absolute top-4 right-4 z-10">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setSelectedPhoto(null)}
                  className="bg-black/50 hover:bg-black/70 text-white"
                >
                  <Icon name="X" size={20} />
                </Button>
              </div>
              <img
                src={selectedPhoto?.photo_url}
                alt={`Foto de verificación del ${new Date(selectedPhoto.proof_date)?.toLocaleDateString('es-ES')}`}
                className="w-full max-h-[80vh] object-contain"
              />
              <div className="p-4 bg-card border-t border-border">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-foreground">
                      {new Date(selectedPhoto.proof_date)?.toLocaleDateString('es-ES', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </p>
                    {selectedPhoto?.notes && (
                      <p className="text-xs text-muted-foreground mt-1">
                        {selectedPhoto?.notes}
                      </p>
                    )}
                  </div>
                  {selectedPhoto?.user_id === currentUserId && (
                    <div className="flex items-center space-x-2 text-xs text-primary">
                      <Icon name="User" size={14} />
                      <span>Tu foto</span>
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ProofPhotoGallery;